var map = {
	"./audio_2_1a.mp3": 1359,
	"./audio_2_1b.mp3": 1360,
	"./audio_2_2a.mp3": 1361,
	"./audio_2_2b.mp3": 1362,
	"./audio_2_3a.mp3": 1363,
	"./audio_2_3b.mp3": 1364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1358;